export const BUTTONS = {
  CREATE_CONTRACT: "انشيء معاملة",
  GO_HOME: "   العودة للرئيسية ",
};
export const TITLE = "عذرا هذا الطلب غير متوفر";
export const DESCRIPTION = "ربما تم بيعه. يرجي التواصل مع البائع";
